module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('App-No1Majalah'), _vm._v(" "), _c('App-No2Fiksyen'), _vm._v(" "), _c('App-No3Agama'), _vm._v(" "), _c('App-No4BukanFiksyen'), _vm._v(" "), _c('App-No5Kanak'), _vm._v(" "), _vm._m(0, false, false)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mid-banner"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://elibrary.yayasanbankrakyat.com.my"
    }
  }, [_c('img', {
    attrs: {
      "id": "mid-banner-img",
      "src": "images/SIR Banner.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-603c689c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Landing2.vue
// module id = 1696
// module chunks = 1